import { create } from "zustand";
import { clearTokens, getConfig, getToken } from "src/storage/helpers";

const initialState = {
  config: null,
  configInitialized: false,
  transcoding: [],
  isRetail: true,
  snackbarText: "",
  isAuthenticated: false,
  applicationInitialized: false,
};

const useGlobalStore = create((set, get) => ({
  /// VARIABLES
  ...initialState,

  // ACTIONS
  initApplication: async () => {
    const token = getToken();
    if (token) {
      await get().initConfig();
    }

    set({
      applicationInitialized: true,
    });
  },

  initConfig: async () => {
    if (get().configInitialized) return;

    set({
      configLoading: true,
    });

    try {
      const data = await getConfig();
      set({
        config: data,
        configInitialized: true,
        configLoading: false,
        isRetail: data?.current_company?.permissions?.type === "R",
        transcoding: data?.current_company?.conversions,
        isAuthenticated: true,
      });
    } catch (error) {
      // if error, remove token, push to signin
      set({
        config: null,
        configInitialized: false,
        configLoading: false,
        snackbarText: "Session has expired error",
        isAuthenticated: false,
      });
      clearTokens();
    }
  },

  refetchConfigBackground: async () => {
    const data = await getConfig();
    set({
      config: data,
      isRetail: data?.current_company?.permissions?.type === "R",
      transcoding: data?.current_company?.conversions,
    });
  },

  addTranscode: (obj) => {
    set({
      transcoding: [...get().transcoding, obj],
    });
  },

  setTranscode: (arr) => {
    set({
      transcoding: arr,
    });
  },

  setSnackbarText: (text) => {
    set({
      snackbarText: text,
    });
  },

  clearSnackbarText: () => {
    set({
      snackbarText: null,
    });
  },

  login: async () => {
    await get().initConfig();
  },

  logout: async () => {
    set({
      isAuthenticated: false,
      config: null,
      configInitialized: false,
    });
  },

  handle401: () => {
    set({
      snackbarText: "Your session has expired error",
      isAuthenticated: false,
      config: null,
      configInitialized: false,
    });
  },
}));

export default useGlobalStore;
